"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayAbilityHandler = exports.ReplayActorAbilityFactory = exports.ReplayAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ReplayAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Replay;
        this.__typeName = "Replay";
    }
}
exports.ReplayAbilityArgs = ReplayAbilityArgs;
let ReplayActorAbilityFactory = class ReplayActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Replay", "All", 0);
    }
};
ReplayActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Replay")
], ReplayActorAbilityFactory);
exports.ReplayActorAbilityFactory = ReplayActorAbilityFactory;
let ReplayAbilityHandler = class ReplayAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const nMissiles = 3 + container.getActor(ability.invokerId).turnCount;
        const lastAttacks = Array.of();
        for (let i = container.events.length - 1; i >= 0; i--) {
            const e = container.events[i];
            if (e.args.__typeName !== "Attacked") {
                continue;
            }
            lastAttacks.push(e.subject);
            if (lastAttacks.length >= nMissiles) {
                break;
            }
        }
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyProjectileAttacksWithDamage({
                    sequence,
                    abilityKey: ability.args.__typeName,
                    attackType: "magic",
                    attackerId: ability.invokerId,
                    projectiles: lastAttacks
                        .map(targetId => ({
                        creatorId: ability.invokerId,
                        targetId,
                        jitter: (0, Random_1.random)(0, 100),
                        type: "ArcaneBolt",
                        path: "arc",
                        damages: [
                            AbilityDamage_1.AbilityDamage.Focus("Chaos", 20)
                        ]
                    }))
                });
            }
        });
    }
};
ReplayAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Replay)
], ReplayAbilityHandler);
exports.ReplayAbilityHandler = ReplayAbilityHandler;
